import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";

function PanelAlarmas() {
  const [alarmas, setAlarmas] = useState([]);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  // ✅ Usa useCallback para evitar recreación en cada render
  const fetchAlarmas = useCallback(() => {
    axios.get(`${API_URL}/api/panel-alarmas/`)
      .then(response => {
        setAlarmas(response.data.alarmas);
      })
      .catch(error => console.error("Error al obtener las alarmas:", error));
  }, [API_URL]);  // ✅ Solo cambiará si `API_URL` cambia

  // ✅ Confirmar alarma y enviar MQTT
  const confirmarAlarma = (idAlarma, nombre) => {
    console.log(`Confirmando alarma con ID: ${idAlarma}`);
    axios.patch(`${API_URL}/api/alarmas/${idAlarma}/`, {
      confirmada: true
    }, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "application/json"
      },
      withCredentials: true  // 🔒 Necesario si usas cookies de sesión
    })
    .then(() => {
      console.log(`✅ Alarma ${idAlarma} confirmada.`);
      
      // 🔴 Enviar mensaje MQTT
      axios.post(`${API_URL}/api/mqtt/`, {
        topic: `ALARMAS/Altura/CONFIRMADA`,
        message: "CONFIRMADA"
      })
      .then(() => {
        console.log(`✅ Mensaje MQTT CONFIRMADA enviado para alarma ${nombre}`);
        fetchAlarmas(); // ✅ Refrescar la lista de alarmas
      })
      .catch(error => console.error("Error al enviar MQTT:", error));
    })
    .catch(error => console.error("Error al confirmar la alarma:", error));
  };

  useEffect(() => {
    fetchAlarmas();
  }, [fetchAlarmas]);  // ✅ Ahora React no muestra advertencias

  
  return (
    <div>
      <h2>📢 Panel de Alarmas (Último Estado)</h2>
      <div className="contenedor">
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Nombre Alarma</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Notificada</th>
              <th>Confirmada</th>
              
              <th>Acciones</th> {/* ✅ Nueva columna para Acciones */}
            </tr>
          </thead>
          <tbody>
            {alarmas.map(alarma => (
              <tr key={alarma.id}>
                <td>{alarma.id}</td>
                <td>{alarma.nombre}</td>
                <td>{new Date(alarma.fecha_hora).toLocaleString()}</td>
                <td>
                  <span className={`badge ${alarma.estado === "ACTIVA" ? "bg-danger" : "bg-success"}`}>
                    {alarma.estado}
                  </span>
                </td>
                <td>
                  <span className={`badge ${alarma.notificada ? "bg-info text-dark" : "bg-secondary"}`}>
                    {alarma.notificada ? "Notificada" : "No Notificada"}
                  </span>
                </td>
                <td>
                  <span className={`badge ${alarma.confirmada ? "bg-success" : "bg-warning text-dark"}`}>
                    {alarma.confirmada ? "Confirmada" : "No Confirmada"}
                  </span>
                </td>

                

                {/* 🔵 Acciones */}
                <td>
                  {alarma.estado === "ACTIVA" && !alarma.confirmada  && (
                    <button 
                      className="btn btn-success btn-sm"
                      onClick={() => confirmarAlarma(alarma.id, alarma.nombre)}
                    >
                      Confirmar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PanelAlarmas;
